import ThemeCustomization from "themes";
import Routes from "routes";
import { useScrollRestoration } from "hooks/useScrollRestoration";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import IsSameAfter from "dayjs/plugin/isSameOrAfter";
import IsSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(duration);
dayjs.extend(IsSameAfter);
dayjs.extend(IsSameOrBefore);

const App = () => {
  // 자동 스크롤 영역 복구 기능
  useScrollRestoration();

  return (
    <ThemeCustomization>
      {/* <ScrollTop> */}
      <Routes />
      {/* </ScrollTop> */}
    </ThemeCustomization>
  );
};

// 배포 환경에서는 console.log, console.error, console.warn을 무시하도록 설정
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
  console.error = function () {};
  console.warn = function () {};
}

export default App;
